module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo5-09211d1c7ca562efc92a295b8f59c5d8.png";